import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Button, Card, Icon } from 'semantic-ui-react';


const headingStyle = {
  paddingTop: 7,
  float: 'left',
  fontSize: 18,
};

const buttonStyle = {
  marginTop: 20,
};


const isValidDate = value => moment(value, moment.ISO_8601, true).isValid();

const FacebookLinkedMC = ({
  id,
  name,
  created_time: createdAt,
  onUnlink,
}) => (
  <Card wide>
    <Card.Content>
      <Card.Header>
        <div style={headingStyle}>
          <Icon.Group size="large">
            <Icon name="facebook" color="blue" className="circular" inverted />
            <Icon corner name="linkify" color="green" />
          </Icon.Group>
          {' '}{name}
        </div>
        <Button
          icon
          className="circular"
          floated="right"
          inverted
          color="pink"
          labelPosition="left"
          style={buttonStyle}
          onClick={() => onUnlink(id)}
        >
          <Icon name="unlinkify" />
            Unlink
        </Button>
      </Card.Header>
    </Card.Content>
    {
      isValidDate(createdAt) && (
        <Card.Content extra>
           created on { moment(createdAt).format('DD MMM YYYY') }
        </Card.Content>
      )
    }

  </Card>
);

FacebookLinkedMC.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  created_time: PropTypes.string.isRequired,
  onUnlink: PropTypes.func.isRequired,
};

export default FacebookLinkedMC;



/** WEBPACK FOOTER **
 ** ./src/components/facebook-linked-mc/index.js
 **/